import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getERPRoomList, getERPRoomListPost } from '@/service/erpAPI';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchERPRoomList = createAsyncThunk(
  'erpRoomList/fetchERPRoomList',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getERPRoomList(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取ERP房间列表失败');
    }
  }
)

export const fetchERPRoomListPost = createAsyncThunk(
  'erpRoomList/fetchERPRoomListPost',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getERPRoomListPost(query);
      console.log('fetchERPRoomListPost', response);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取ERP房间列表失败');
    }
  }
)

const erpRoomSlice = createSlice({
  name: 'erpRoomList',
  initialState: defaultState,
  reducers: {
    resetERPRoomListState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchERPRoomList.pending, (state) => {
        state.fetching = true;
        state.error = null;
      })
      .addCase(fetchERPRoomList.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchERPRoomList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      })
      .addCase(fetchERPRoomListPost.pending, (state) => {
        state.fetching = true;
        state.error = null;
      })
      .addCase(fetchERPRoomListPost.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchERPRoomListPost.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})

export const { resetERPRoomListState } = erpRoomSlice.actions;
export default erpRoomSlice.reducer;
